import React from 'react';

// Componente para a seção "Nossos Serviços"
const Servicos: React.FC = () => {
  return (
    <section id="servicos" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title">Serviços personalizados para suas necessidades</h2>
          <p className="section-subtitle">
            Oferecemos uma ampla gama de serviços personalizados para atender às necessidades 
            específicas de cada cliente, independente do tamanho ou setor de atuação.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Serviço 1 */}
          <div className="card group hover:shadow-2xl transition-all duration-300">
            <div className="text-lupa-orange mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Laboratório de ciência de dados</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Solução personalizada de ciência de dados projetada para solucionar desafios específicos, 
              por meio de tecnologias avançadas.
            </p>
          </div>
          
          {/* Serviço 2 */}
          <div className="card group hover:shadow-2xl transition-all duration-300">
            <div className="text-lupa-orange mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Personalização de fluxo de dados</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Serviço de personalização projetado para auxiliar na gestão de grandes volumes de dados 
              e na otimização de processos.
            </p>
          </div>
          
          {/* Serviço 3 */}
          <div className="card group hover:shadow-2xl transition-all duration-300">
            <div className="text-lupa-orange mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Instalação de ambientes de big data</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Serviço de implementação e gerenciamento de soluções em Big Data, empregando 
              tecnologias de ponta para resultados eficientes.
            </p>
          </div>
          
          {/* Serviço 4 */}
          <div className="card group hover:shadow-2xl transition-all duration-300">
            <div className="text-lupa-orange mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-3">Revenda autorizada de licenças</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Como parte da estratégia de oferecer soluções integrais em Big Data, atuamos como 
              revendedor autorizado de licenças de software especializado.
            </p>
          </div>
        </div>
        
        <div className="mt-16 text-center">
          <a href="/servicos" className="btn-primary inline-block">Conheça todos os serviços</a>
        </div>
      </div>
    </section>
  );
};

export default Servicos;
